import { useEffect, useState } from "react";
import { http } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AlertTriangle, DatabaseBackup, LogOut, Timer } from "lucide-react";

export default function MaintenanceBanner() {
  const { user, logout, isAdmin } = useAuth();
  const [st, setSt] = useState(null);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const tick = () => http.get("/maintenance-status").then((r) => setSt(r.data)).catch(() => {});
    tick();
    const t = setInterval(tick, 60000);
    const s = setInterval(() => setNow(Date.now()), 1000);
    return () => { clearInterval(t); clearInterval(s); };
  }, []);
  if (!st || st.phase === "none" || !user) return null;
  const target = new Date(st.phase === "backup" ? st.backup_end : st.backup_at).getTime();
  const left = Math.max(0, Math.floor((target - now) / 1000));
  const countdown = `${String(Math.floor(left / 60)).padStart(2, "0")}:${String(left % 60).padStart(2, "0")}`;

  if (st.phase === "backup" && !isAdmin) {
    return (
      <div className="fixed inset-0 z-[100] bg-slate-900/95 text-white flex items-center justify-center p-6" data-testid="maintenance-lock">
        <div className="max-w-lg text-center space-y-4">
          <DatabaseBackup className="w-14 h-14 mx-auto text-amber-400 animate-pulse" />
          <h2 className="text-2xl font-bold">Şu an yedekleme yapılıyor</h2>
          <p className="text-slate-200" data-testid="maintenance-lock-msg">{st.message}</p>
          <div className="font-mono text-3xl font-bold text-amber-300" data-testid="maintenance-countdown">{countdown}</div>
          <div className="text-xs text-slate-400">tekrar girişe kalan süre</div>
          <button type="button" onClick={logout} className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-amber-500 text-slate-900 font-bold text-sm hover:bg-amber-400" data-testid="maintenance-logout"><LogOut className="w-4 h-4" /> Çıkış Yap</button>
        </div>
      </div>
    );
  }
  return (
    <div className={`sticky top-0 z-50 flex items-center gap-2 px-4 py-2 text-sm font-semibold ${st.phase === "backup" ? "bg-red-600 text-white" : "bg-amber-400 text-slate-900"}`} data-testid="maintenance-banner">
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span data-testid="maintenance-banner-msg">{st.phase === "backup" ? `Yedekleme sürüyor (yönetici görünümü). ${st.message}` : st.message}</span>
      <span className="ml-auto inline-flex items-center gap-1.5 font-mono text-base font-bold px-2 py-0.5 rounded bg-black/15" data-testid="maintenance-countdown"><Timer className="w-4 h-4" /> {countdown}<span className="text-[10px] font-sans font-semibold opacity-80">{st.phase === "backup" ? "kilit bitişine" : "yedeklemeye"}</span></span>
    </div>
  );
}
